"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactRouterDom = require("react-router-dom");
var _dompurify = _interopRequireDefault(require("dompurify"));
var _core = require("core.ui-module_site-components");
var _MsalClientConfig = require("../../api/azure/MsalClientConfig");
var _msalBrowser = require("@azure/msal-browser");
var _AzureAuthenticationStepResponse = _interopRequireDefault(require("../../api/auth/AzureAuthenticationStepResponse"));
var _AzureStatus = require("../../api/azure/AzureStatus");
var _ApplicationContext = require("../../api/ApplicationContext");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
class AzureAuthenticationStep extends _react.default.Component {
  constructor(props) {
    super(props);
    this.state = {
      errorMessage: ''
    };
  }
  componentDidMount() {
    const azureStatus = _AzureStatus.AzureStatus.get();
    if (azureStatus.isErrant()) {
      this.setState({
        errorMessage: `<div>${azureStatus.getMessage()}</div>`
      });
    } else if (azureStatus.isNew()) {
      this.startSSO(azureStatus);
    } else if (azureStatus.isAuthenticationReady()) {
      this.submit(azureStatus);
    }
  }
  submit() {
    _AzureStatus.AzureStatus.reset();
    this.props.history.push(_ApplicationContext.ApplicationContext.getLoginPath());
  }
  submit(azureStatus) {
    const step = new _AzureAuthenticationStepResponse.default();
    step.accessToken = azureStatus.getAccessToken();
    step.identityToken = azureStatus.getIdentityToken();
    azureStatus.setComplete();
    this.props.listener(this, step);
  }
  startSSO(azureStatus) {
    this.setState({
      isLoading: true
    });
    const msalInstance = new _msalBrowser.PublicClientApplication((0, _MsalClientConfig.msalConfig)());
    msalInstance.acquireTokenRedirect(_MsalClientConfig.loginRequestNoPrompt).catch(e => {});
  }
  render() {
    const {
      errorMessage
    } = this.state;
    if (errorMessage !== '') {
      return /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_core.OkModal, {
        header: "Authentication Error",
        message: errorMessage,
        display: errorMessage !== '',
        key: errorMessage
      }), /*#__PURE__*/_react.default.createElement("div", {
        className: "login-box content"
      }, /*#__PURE__*/_react.default.createElement("p", {
        className: "title",
        dangerouslySetInnerHTML: {
          __html: _ApplicationContext.ApplicationContext.getLoginGreetingTitle() ? _dompurify.default.sanitize(_ApplicationContext.ApplicationContext.getLoginGreetingTitle()) : 'Welcome back'
        }
      }), /*#__PURE__*/_react.default.createElement("p", {
        className: "subtitle"
      }, "Log in to the ", _ApplicationContext.ApplicationContext.getSiteName()), /*#__PURE__*/_react.default.createElement("div", {
        className: "content"
      }, /*#__PURE__*/_react.default.createElement("form", {
        id: "loginForm",
        method: "post",
        onSubmit: e => this.submit(e)
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "field"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "control"
      }, /*#__PURE__*/_react.default.createElement(_core.Button, {
        className: "is-primary is-fullwidth"
      }, "Try Again")))))));
    }
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null);
  }
}
AzureAuthenticationStep.propTypes = {
  listener: _propTypes.default.func.isRequired
};
var _default = exports.default = (0, _reactRouterDom.withRouter)(AzureAuthenticationStep);
//# sourceMappingURL=AzureAuthenticationStep.js.map